import {
  IonCard,
  IonCardContent,
  IonItem,
  IonList,
  IonText,
  IonThumbnail,
} from "@ionic/react";
import { getCurrentTechnoOrDisconnect } from "../../variables/jobDictionnary";
import "./ItemWorkAside.css";
import itemsAside from "./asideInterface";

interface Props {
  type: string;
}

const ItemWorkAside: React.FC<Props> = ({ type }) => {
  const urlParams = new URLSearchParams(window.location.search);
  let items = itemsAside.get(type) ?? [];

  if (
    getCurrentTechnoOrDisconnect() === "boul" &&
    urlParams.get("type") === "tp"
  ) {
    items = items.filter(
      (i) =>
        i.title !== "Mes fiches techniques" &&
        i.title !== "Mon planning des Live"
    );
  }
  return (
    <IonList
      className="border-primary-contrast border-radius"
      style={{ padding: "15px" }}
    >
      {items.map((item, i) => (
        <IonCard
          key={i}
          href={item.href + (i === 0 ? "?type=" + type : "")}
          color="light"
          className="card card-theme"
        >
          <IonCardContent className="card-content background-item-card no-padding">
            <IonItem
              color="transparent"
              style={{ margin: "5px", padding: "5px" }}
            >
              <IonThumbnail
                slot="start"
                style={{ marginTop: "0", marginBottom: "0" }}
                className="no-margin"
              >
                <img alt="vignette" src={item.iconLink} />
              </IonThumbnail>
              <div className="separator"></div>
              <IonText>
                <h5>{item.title}</h5>
              </IonText>
            </IonItem>
          </IonCardContent>
        </IonCard>
      ))}
    </IonList>
  );
};

export default ItemWorkAside;
